import Head from "next/head";
import React from "react";

function SEO({ title, desc = "" }) {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <title>{title}</title>
        <meta name="description" content={desc} />
        <meta name="keywords" content="sloths, send a sloth, sloth gifts" />
        <meta name="author" content="Mitesh Patel" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
    </>
  );
}

export default SEO;
